/* Created by cihong.liu */

/** 当前数据中心 */
export const CurrentDbCode = () => sessionStorage.getItem('db-code') || 'XH';